import React from 'react';
import {Close} from '@material-ui/icons';
import {Theme, createStyles, makeStyles, Button} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {
  APP,
  BLACK_COLOR,
  DEFAULT_RED_COLOR,
  GET_8_PIXEL_BOX
} from 'src/style/variable';
// import TimerIcon from '@components/system/MyIcons/TimerIcon';
// import AlarmIcon from '@material-ui/icons/Alarm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorPage: {
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'inherit'
    },
    machineCloseIcon: {
      background: DEFAULT_RED_COLOR,
      color: '#FFFFFF',
      borderRadius: '50%',
      height: '90px',
      width: '90px',
      margin: '2rem 0 2rem 0'
    },
    alarmIconComponent: {
      height: '100px',
      width: '100px',
      marginBottom: '2rem',
      color: `${APP.COLOR.PRIMARY} !important`
    },
    errorPageText: {
      maxWidth: '100px',
      fontWeight: 600,
      fontSize: '20px',
      marginRight: '1.5rem'
    },
    errorPageTextMessage: {
      color: DEFAULT_RED_COLOR,
      textAlign: 'center'
    },
    errorPageTextFailed: {
      maxWidth: '100px',
      fontWeight: 600,
      marginLeft: '2rem',
      fontSize: '20px',
      marginRight: '1.5rem'
    },
    errorButton: {
      marginTop: '3rem',
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '3.5rem',
      width: '12rem'
    },
    timeoutButton: {
      marginTop: '5rem',
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '3.5rem',
      width: '12rem',
      fontSize: '16px',
      color: `${BLACK_COLOR} !important`,
      border: '0px !important',
      marginLeft: '6rem',
      cursor: 'pointer'
    },
    transactionTimeoutButton: {
      marginTop: '5rem',
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '3.5rem',
      width: '12rem',
      fontSize: '16px',
      color: `${BLACK_COLOR} !important`,
      border: '0px !important',
      marginLeft: '6rem',
      cursor: 'pointer'
    }
  })
);
// TODO: Give proper types to the below interface
interface ErrorPageProps {
  changePaymentPlanOptions: any;
  setLoaderComponent: any;
  cardMachineErrorMessage?: string;
  cardMachineDetailsObject?: any;
}

const ErrorPage = (props: ErrorPageProps): React.ReactElement => {
  const {
    changePaymentPlanOptions,
    // setLoaderComponent,
    cardMachineErrorMessage,
    cardMachineDetailsObject
  } = props;
  const classes = useStyles();
  const {t} = useTranslation();
  // const [alarmIcon, setAlarmIcon]: any = useState(false);

  const backToChangePaymentPlanOptions = () => {
    if (typeof changePaymentPlanOptions === 'function') {
      changePaymentPlanOptions();
    }
  };

  // const setAlarmIconComponent = () => {
  //   setAlarmIcon(true);
  // };
  return (
    <div className={classes.errorPage}>
      {<Close className={classes.machineCloseIcon} />}

      {/* commented out the below code related WAIT button */}
      {/* {alarmIcon && <TimerIcon className={classes.alarmIconComponent} />} */}

      {/* <div className={classes.errorPageText}>
        {t('PAYMENTS_LOGIN.CARD.ERROR_PAGE_MESSAGE_TRANSCATION')}
      </div> */}
      {/* {!alarmIcon && (
        <div className={classes.errorPageTextFailed}>
          {t('PAYMENTS_LOGIN.CARD.ERROR_PAGE_MESSAGE_TRANSCATION_FAILED')}
        </div>
      )} */}
      {/* {alarmIcon && (
        <div className={classes.errorPageTextFailed}>
          {t('PAYMENTS_LOGIN.CARD.ERROR_PAGE_MESSAGE_TRANSCATION_TIMEOUT')}
        </div>
      )} */}
      <div className={classes.errorPageTextMessage}>
        {cardMachineDetailsObject?.status !== 'inactive'
          ? cardMachineErrorMessage
          : `${cardMachineDetailsObject?.machine_name} is inactive, please try making the payment with  an active one`}
      </div>
      <Button
        fullWidth
        variant="contained"
        size={'medium'}
        color="primary"
        className={[classes.errorButton].join(' ')}
        type={'submit'}
        style={{height: '3.5rem'}}
        onClick={backToChangePaymentPlanOptions}>
        {t('PAYMENTS_LOGIN.CARD.TRY_AGAIN')}
      </Button>

      {/* commented out the below code related WAIT button */}
      {/* {!alarmIcon && cardMachineDetailsObject?.status !== 'inactive' && (
        <div
          className={[classes.timeoutButton].join(' ')}
          onClick={setAlarmIconComponent}>
          {t('PAYMENTS_LOGIN.CARD.TIME_OUT')}
        </div>
      )} */}
      {/* {cardMachineDetailsObject?.status !== 'inactive' && (
        <div
          className={[classes.transactionTimeoutButton].join(' ')}
          onClick={setLoaderComponent}>
          {t('PAYMENTS_LOGIN.CARD.WAITING')}
        </div>
      )} */}
    </div>
  );
};

export default ErrorPage;
